import { Boundaries } from "@planzone/core";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { State } from "./types";

function handleSuccess(
  state: State,
  {
    notifications,
    filter,
    totalPages,
  }: Boundaries["retrieveNotifications"]["success"],
): State {
  return {
    ...state,
    notifications:
      filter.start === 0
        ? notifications
        : [...state.notifications, ...notifications],
    request: setRequestStateToSuccess(),
    totalPages,
  };
}

export { handleSuccess };
